import type { ToolkitTool } from '@/api/toolkit';
import { ToolkitPromptFormModal } from '@/ui/components/ToolkitPromptFormModal';
import { useUpdateUserToolkitPrompt } from '../hooks';

export interface EditUserToolkitPromptModalProps {
  visible: boolean;
  onHide: () => void;
  tool: ToolkitTool | null;
  onUpdated?: (tool: ToolkitTool) => void;
}

export const EditUserToolkitPromptModal = ({ visible, onHide, tool, onUpdated }: EditUserToolkitPromptModalProps) => {
  const { handleSubmit, isLoading } = useUpdateUserToolkitPrompt({
    tool,
    onSuccess: onHide,
    onUpdated,
  });

  if (!tool) return null;

  return (
    <ToolkitPromptFormModal
      visible={visible}
      onHide={onHide}
      title="Edit prompt"
      formKey={tool.toolId}
      initialValues={{
        toolName: tool.toolName,
        toolDescription: tool.description,
        prompt: tool.prompt,
      }}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
};
